import { render, staticRenderFns } from "./DateTimeLabel.vue?vue&type=template&id=bada61cc"
import script from "./DateTimeLabel.vue?vue&type=script&lang=js"
export * from "./DateTimeLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports